import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAlertAuditLogs} from 'src/openapi/admin/apis/PlatformAlertsApi';

import type {ApiDispatchForToolkit} from 'src/openapi/admin/types';

type Props = {
    alertId: number,
};

export const useGetChangeLog = ({alertId}: Props) => {
    const apiDispatch = useDispatch<ApiDispatchForToolkit>();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getAlertAuditLogs({alertId}, {signal}),
    ), [apiDispatch, alertId]);

    return useReadOnlyDataHook({initValue: [], getDispatchAction});
};
